import React from 'react';
import { FaTruck } from 'react-icons/fa';
import { IoIosLock } from 'react-icons/io';
import ScrollReveal from "../../components/ScrollReveal";
import { useLanguage } from "../../contexts/LanguageContext";

type GreenCubeItemProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

const GreenCubeItem: React.FC<GreenCubeItemProps> = ({ icon, title, description }) => {
  return (
    <div className="flex items-start mb-6">
      <div className="bg-[#83C441] p-4 rounded-full mr-5 flex items-center justify-center">
        {icon}
      </div>
      <div>
        <h2 className="text-lg font-bold text-[#282A2A]">{title}</h2>
        <p className="text-[#282A2A]/90 mt-2">
          {description}
        </p>
      </div>
    </div>
  );
};

const Montelo: React.FC = () => {
  const { t, tString } = useLanguage();
  return (
    <section id="montelo" className="w-screen px-16 py-16 relative overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div
          className="w-full h-full bg-cover bg-center md:bg-fixed"
          style={{ backgroundImage: "url('/images/trucks.png')" }}
        >
          <div className="w-full h-full bg-white/80" />
        </div>
      </div>

      {/* Foreground content */}
      <div className="relative z-10 scroll-mt-40 flex flex-col-reverse md:flex-row items-center justify-center gap-14 max-w-7xl mx-auto">


        {/* DATA */}
        <div className="w-full md:w-1/2 text-left">
          <ScrollReveal direction="up" delay={0.3} duration={0.8}>
            <div className="flex flex-col md:flex-row md:items-center md:space-x-3 mb-4">
              <h1 className="text-3xl font-rockwell font-bold text-[#282A2A] mr-4">
                {t('montelo.title')}
              </h1>
              <img
                src="/images/certificate_gb.png"
                alt="Certificado"
                className="w-36 h-auto mt-2 md:mt-0"
              />
            </div>
          </ScrollReveal>
          <ScrollReveal direction="up" delay={0.4} duration={0.8}>
            <p className="text-[#282A2A]/90 text-md text-light mb-8">
              {t('montelo.description')}
            </p>
          </ScrollReveal>

          <ScrollReveal direction="left" delay={0.5} duration={0.8}>
            <GreenCubeItem
              icon={<FaTruck className="text-white text-xl" />}
              title={tString('montelo.features.landTransport.title')}
              description={tString('montelo.features.landTransport.description')}
            />
          </ScrollReveal>
          <ScrollReveal direction="left" delay={0.6} duration={0.8}>
            <GreenCubeItem
              icon={<IoIosLock className="text-white text-xl" />}
              title={tString('montelo.features.secureConnection.title')}
              description={tString('montelo.features.secureConnection.description')}
            />
          </ScrollReveal>

          {/* Button */}
          <ScrollReveal direction="left" delay={0.8} duration={0.8}>
            <a href="https://www.montelo-express.com/" target="_blank" rel="noopener noreferrer" className="flex justify-center sm:justify-start">
              <button className="bg-[#83C441] text-white mt-3 py-2 px-8 rounded-md hover:bg-lime-600 transition duration-200">
                {t('montelo.visitWebsite')}
              </button>
            </a>
          </ScrollReveal>
        </div>

        {/* IMAGE */}
        <div className="w-full md:w-1/2">
          <ScrollReveal direction="right" delay={0.2} duration={0.8}>
            <img
              src="/images/logo_montelo.png"
              alt="Servicio de transporte Montelo"
              className="w-[550px] h-[300px] md:h-[500px] object-contain rounded-xl"
            />
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default Montelo;
